/**
 * internal dependencies
 */
import { INewPartner } from '../../../models/partner.interface';

/**
 * Function to parse parnter data for dropdown multi select.
 * 
 * @param {object} data the api response data
 */
export const parsePartnerDataForSort = (data: INewPartner[]) => {
  const partnerList = document.querySelector('.aafp_filter-partners-list') as HTMLElement;
  const fragment = document.createDocumentFragment();

  const pList = data.map((key: INewPartner) => {
    return { 'ID': key.partnerID, 'Name': key.partnerName };
  });

  for (const { ID, Name } of pList) {
    const div = document.createElement('div');
    div.classList.add('aafp_checkbox-container');

    const label = document.createElement('label');
    label.classList.add('form-check-label');
    label.htmlFor = `defaultCheck${ID}`;
    label.textContent = Name;

    const input = document.createElement('input');
    input.classList.add('form-check-input', 'aafp_part', 'table-filter-clear');
    input.type = 'checkbox';
    input.value = ID!;
    input.id = `defaultCheck${ID}`;

    const span = document.createElement('span');
    span.classList.add('aafp_checkmark');

    label.appendChild(input);
    label.appendChild(span);
    div.appendChild(label);
    fragment.appendChild(div);
  }

  partnerList.appendChild(fragment);
}
